import { memo } from 'react';
import { CapacityType } from '../../types/CapacityType.interface';
import SortedSelect, { SortedSelectProps } from './SortedSelect';

export type CapacityTypeSelectProps = {
    selectedCapacityType: number;
    capacityTypeOptions: CapacityType[];
    sortByOrder?: boolean;
} & Omit<SortedSelectProps<CapacityType>, 'selectedValue' | 'options'>;

function sortByOrderFunction(a: CapacityType, b: CapacityType) {
    if (a.id === -1) return -1;
    if (b.id === -1) return 1;
    return a.sort - b.sort;
}

function CapacityTypeSelect({
    selectedCapacityType,
    capacityTypeOptions,
    onChange,
    label = 'Capacity Type',
    sortByName = true,
    sortByOrder = false,
    ...props
}: CapacityTypeSelectProps) {
    return (
        <SortedSelect
            selectedValue={selectedCapacityType}
            options={capacityTypeOptions}
            onChange={onChange}
            label={label}
            sortByName={sortByOrder ? false : sortByName}
            sortFunction={sortByOrder ? sortByOrderFunction : undefined}
            {...props}
        />
    );
}

export default memo(CapacityTypeSelect);
